import { Grid } from '@mui/material'
import { ExecutedMovesEquipmentDto } from '@operations/app/api'
import { observer } from 'mobx-react-lite'
import { IVesselKPIColumn } from '../../models/vessel-kpi'
import { VesselKpiTableCell } from '../atoms/VesselKpiTableCell'

interface Props {
  column: IVesselKPIColumn
  craneMove?: ExecutedMovesEquipmentDto
}
export const CraneTableContent = observer(({ column, craneMove }: Props) => {
  return (
    <Grid container spacing={1}>
      {column.hasInbound && (
        <VesselKpiTableCell column={column} value={craneMove?.inboundAmount ?? 0} />
      )}

      {column.hasOutbound && (
        <VesselKpiTableCell column={column} value={craneMove?.outboundAmount ?? 0} />
      )}

      {column.hasRestow && (
        <VesselKpiTableCell column={column} value={craneMove?.restowAmount ?? 0} />
      )}

      <VesselKpiTableCell column={column} value={craneMove?.total ?? 0} />
    </Grid>
  )
})
